module.exports = __webpack_public_path__ + "static/media/易融术@2x.25ece06c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/易融术@2x.png
// module id = 1576
// module chunks = 0